import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-card',
  template: `<div class="rounded-lg border border-border bg-white shadow-sm"><ng-content /></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {}

@Component({
  selector: 'app-card-header',
  template: `<div class="flex flex-col p-6 pb-3"><ng-content /></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent {}

@Component({
  selector: 'app-card-title',
  template: `<h3 class="text-lg font-semibold"><ng-content /></h3>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTitleComponent {}

@Component({
  selector: 'app-card-content',
  template: `<div class="p-6 pt-0"><ng-content /></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardContentComponent {}

@Component({
  selector: 'app-card-footer',
  template: `<div class="flex items-center p-6 pt-0"><ng-content /></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFooterComponent {}
